<template>
  <basic-dialog
    class="dataTypeDlg"
    :visible="visible"
    :show-ft="action !== 'view'"
    :title="addOrEdit"
    :width="760"
    :update-vis="updateVis"
    :handle-close="handleClose"
    :handle-closed="handleClosed"
    :handle-ok="handleOk"
    :isDisabled="isDisabled"
    :okText="this.action == 'add' ? `${$t('language.5o6vkto5xjo0')}` : `${$t('language.5o6u3frcn9k0')}`"
    :close-text="this.action != 'view' ? `${$t('language.5o6u3frcn8k0')}` : `${$t('language.5o6uut7rgac0')}`"
  >
    <el-form
      ref="form"
      size="small"
      label-position="left"
      label-width="100px"
      :model="dto"
      :rules="rules"
      @submit.native.prevent
    >
      <div class="entity-dlg__block">
        <div class="entity-dlg__block-bd">
          <el-row :gutter="24">
            <el-col :span="12">
              <!--{{dto.appCode}}-->
              <el-form-item :title="$t('language.5o6vkto5ycw0')" :label="$t('language.5o6vkto5ycw0')" prop="appCode">
                <!-- <el-select  v-if="action=='add'"  filterable v-model="dto.appCode" @change="changeSelectObj" value-key="appCode">
                                    <el-option v-for="(item, key) of options" :key="key" :label="item.appName"
                                               :value="item.appCode"/>
                                </el-select> -->

                <el-select
                  :disabled="isDisabled('appCode')"
                  filterable
                  v-model="dto.appCode"
                  @change="chooseEditParam"
                >
                  <el-option
                    v-for="(item, key) of options"
                    :key="key"
                    :label="item.appName"
                    :value="item.appCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('language.5o6vk82zm540')" prop="typeName">
                <el-input v-model.trim="dto.typeName" :disabled="isDisabled('typeName')" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item :label="$t('language.5o6vk82zm180')" prop="typeCode">
                <!--:disabled="isDisabled('typeCode')||!dto.typeName"-->
                <el-input
                  v-model.trim="dto.typeCode"
                  :disabled="isDisabled('typeCode')"
                  :placeholder="$t('language.5o6vkto5yks0')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item :label="$t('language.5o6otz4p1w00')" prop="remark">
                <el-input
                  clearable
                  v-model="dto.remark"
                  type="input"
                  :rows="3"
                  maxlength="121"
                  :disabled="isDisabled('remark')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="entity-dlg__block">
            <el-table max-height="500" :data="dto.dataExtInfoList" style="width: 100%">
              <el-table-column type="extNo" :label="$t('language.5o6v4bolfsc0')" width="100">
                <template slot-scope="scope">
                  {{ scope.row.extNo }}
                </template>
              </el-table-column>
              <el-table-column prop="isEffective" :label="$t('language.5o6v4bolfv40')" width="150">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.isEffective"
                    :disabled="isDisabled('isEffective')"
                    :true-label="1"
                    :false-label="0"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="isRequired" :label="$t('language.5o6vkto5yvg0')" width="180">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.isRequired"
                    :disabled="isDisabled('isRequired')"
                    :true-label="1"
                    :false-label="0"
                  >
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column property="extName" :label="$t('language.5o6v4bolg0c0')" width="100">
                <template slot-scope="scope">
                  <el-input
                    size="mini"
                    v-model="scope.row.extName"
                    :disabled="isDisabled('extName')"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="isEnum" :label="$t('language.5o6v4bolg340')" width="200">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.isEnum"
                    :disabled="isDisabled('isEnum')"
                    :true-label="1"
                    :false-label="0"
                  >
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column width="200" prop="enumValue" :label="$t('language.5o6v4bolg5s0')" >
                <template slot-scope="scope">
                  <el-input
                    size="mini"
                    v-model="scope.row.enumValue"
                    :disabled="isDisabled('enumValue')"
                    :placeholder="$t('language.5o6vkto5z640')"
                  />
                </template>
              </el-table-column>
              <!--  <el-table-column
                                  property="isUnique"
                                  label="是否唯一标识"
                                  width="150">
                                  <template slot-scope="scope">
                                      <el-checkbox v-model="scope.row.isUnique" :disabled="isDisabled('isUnique')"
                                                   :true-label=1 :false-label=0></el-checkbox>
                                  </template>
                              </el-table-column>
                              <el-table-column
                                  property="isShowName"
                                  label="是否显示名称"
                                  width="150">
                                  <template slot-scope="scope">
                                      <el-checkbox v-model="scope.row.isShowName" :disabled="isDisabled('isShowName')"
                                                   :true-label=1 :false-label=0></el-checkbox>
                                  </template>
                              </el-table-column>-->
            </el-table>
          </div>
        </div>
      </div>
    </el-form>
  </basic-dialog>
</template>

<script>
import { mapState } from "vuex";
import EntityDialog from "@/mixins/entityDialog";
export default {
  mixins: [EntityDialog],
  props: {
    okText: String,
  },
  data() {
    return {
      rules: {
        typeCode: [
          { required: true, message: `${this.$t('language.5o6vkto5zdk0')}`, trigger: "blur" },
          { max: 30, message: `${this.$t('language.5o6ukqm44hk0')}`,trigger:['change','blur'] },
          // { pattern: CNST.REG_EXP.ENGNUMLINE, message: "50字符(字母、数字、下划线)" },
          { pattern: CNST.REG_EXP.ENGNUMLINE, message: `${this.$t('language.5o6vkto5zgc0')}` },
          {
            validator: (rule, value, callback) => {
              if (this.action == "add") {
                api.dataType
                  .codeExist({
                    data: {
                      typeCode: this.dto.typeCode,
                      tenementCode: this.$store.state.app.tenementInfoObj.tenementCode,
                    },
                  })
                  .then((res) => {
                    if (res.code == "200") {
                      if (res.data) {
                        return callback(new Error(`${this.$t('language.5o6vkto5zkg0')}`));
                      } else {
                        return callback();
                      }
                    } else {
                      // console.log('接口报错码', res.code)
                      this.$message.error(res.msg || res.errorCode || `${this.$t('language.5o6vkto5zmk0')}`);
                      return false;
                      //return callback(new Error(res.msg || res.errorCode || '请联系管理员'))
                    }
                  });
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        typeName: [
          { required: true, message: `${this.$t('language.5o6vkto5zow0')}` },
          // { pattern: CNST.REG_EXP.NORMAL, message: "类型名称不可输入特殊字符" },
          { max: 40, message: `${this.$t('language.5o6vkto5zr40')}` },
          {
            validator: (rule, value, callback) => {
              let data = {};
              if (this.action === "add") {
                data = {
                  typeName: this.dto.typeName,
                  tenementCode: this.$store.state.app.tenementInfoObj.tenementCode,
                };
              } else {
                data = {
                  typeName: this.dto.typeName,
                  id: this.dto.id,
                  tenementCode: this.$store.state.app.tenementInfoObj.tenementCode,
                };
              }
              api.dataType
                .nameExist({
                  data,
                })
                .then((res) => {
                  if (res && res.code == "200") {
                    if (res.data) {
                      return callback(new Error(`${this.$t('language.5o6vkto5ztc0')}`));
                    } else {
                      return callback();
                    }
                  } else if (res) {
                    this.$message.error(res.msg || res.errorCode || `${this.$t('language.5o6vkto5zmk0')}`);
                  }
                });
            },
            trigger: "blur",
          },
        ],
        appName: [{ required: true, message: `${this.$t('language.5o6vkto5zv80')}` }],
        appCode: [{ required: true, message: `${this.$t('language.5o6vkto5zv80')}` }],
        remark: [
          { max: 120, message: `${this.$t('language.5o6vg67fntc0')}` },
        ],
      },
      appCodeData: "",
      appIdData: "",
      appIdDataEdit: "", //修改时候的必传参数 appId
      addOrEdit: null,
    };
  },

  beforeCreate() {
    this.allFields = [
      "typeName",
      "typeCode",
      "remark",
      //  {key: "appCode", default: "msp"}, {key: "appId", default: 1},
      "appCode",
      "appId",
      { key: "tenementCode", default: "xinzhou",  },
      { key: "tenementId", default: 1,width: '200px' },
      { key: "id", default: "",width: '200' },
      { key: "source", default: "",width: '200' },
      {
        key: "dataExtInfoList",
        default: (function () {
          const list = [];
          for (let i = 1; i <= 18; i++) {
            const row = {
              extNo: i,
              extName: "",
              isEffective: 0,
              isShowName: 0,
              isUnique: 0,
              isRequired: 0,
              isEnum: 0,
              enumValue: "",
            };
            if (i === 1) {
              row.typeId = 1;
            }
            list.push(row);
          }
          return list;
        })(),
      },
    ];
    this.disFieldKeys = ["typeCode", "appCode"];
  },
  created() {
    this.addOrEdit = this.buttonData("tjsjlx").name;
  },
  computed: {
    ...mapState("app", ["appList", "tenementCode"]),
    options(newVal) {
      if (this.action === "add" && this.appList.length) {
        this.dto.appCode = this.appList[0].appCode;
        this.dto.appName = this.appList[0].appName;
        this.dto.appId = this.appList[0].id;
      }
      return this.appList;
    },
  },
  methods: {
    // handleOk() {
    //   this.$refs.form.validate(valid => {
    //     if (!valid) {
    //       return false
    //     }
    //     else {
    //       let dataExtInfoList = []
    //       for (let i = 0; i < this.dto.dataExtInfoList.length; i++) {
    //         if (this.dto.dataExtInfoList[i].isEnum === 1 && _.isEmpty(this.dto.dataExtInfoList[i].enumValue)) {
    //           this.$message.error('已选择枚举类型的字段必须输入枚举值')
    //           return
    //         }
    //         if (i < 9 && this.dto.dataExtInfoList[i + 1].isEffective == 1 && this.dto.dataExtInfoList[i].isEffective == 0) {
    //           this.$message.error('只能依次启用各字段，当前字段' + this.dto.dataExtInfoList[i].extNo + '未启用')
    //           return false
    //         }
    //         if (i < 10 && this.dto.dataExtInfoList[i].extName.length == 0 && this.dto.dataExtInfoList[i].isEffective == 1) {
    //           this.$message.error('字段' + this.dto.dataExtInfoList[i].extNo + '启用状态下须填写字段名称')
    //           return false
    //         }
    //         if (i < 9 && this.dto.dataExtInfoList[i + 1].extName && !this.dto.dataExtInfoList[i].extName) {
    //           this.$message.error('请按顺序填写字段名称')
    //           return false
    //         }
    //         else {
    //           if (i < 10 && this.dto.dataExtInfoList[i].extName.length > 20) {
    //             this.$message.error('字段' + this.dto.dataExtInfoList[i].extNo + '的字段名称长度不得超过20位')
    //             return false
    //           } else if (i < 18 && this.dto.dataExtInfoList[i].extName) {
    //             dataExtInfoList.push(this.dto.dataExtInfoList[i])
    //           }
    //         }
    //       }
    //       let topField = this.toEnd()
    //       if (this.dto.appName) {
    //         topField = _.omit(topField, 'appName')
    //       }
    //       const extFileds = _.cloneDeep(dataExtInfoList)
    //       if (!extFileds.some(item => item.isRequired === 1)) {
    //         this.$message.error('必须有一个必填字段')
    //         return
    //       }
    //       for (let i = 0, len = extFileds.length; i < len; i++) {
    //         if (extFileds[i].isEnum === 1 && !_.isEmpty(extFileds[i].enumValue)) {
    //           const enumStr = extFileds[i].enumValue.trim()
    //           if (enumStr.includes(',')) {
    //             const keys = []
    //             const values = []
    //             const array = enumStr.split(',')
    //             for (let j = 0; j < array.length; j++) {
    //               if (!array[j].includes(':')) {
    //                 this.$message.error('枚举值请使用key:value格式')
    //                 return
    //               } else {
    //                 const itemInfo = array[j].split(':')
    //                 const itemKey = itemInfo[0].trim()
    //                 const itemValue = itemInfo[1].trim()
    //                 if (!itemKey || !itemValue) {
    //                   this.$message.error('key或value不能为空')
    //                   return
    //                 }
    //                 if (keys.includes(itemKey)) {
    //                   this.$message.error(`枚举值的key值${itemKey}不允许重复`)
    //                   return
    //                 } else {
    //                   keys.push(itemKey)
    //                 }
    //                 if (values.includes(itemValue)) {
    //                   this.$message.error(`枚举值的value值${itemValue}不允许重复`)
    //                   return
    //                 } else {
    //                   values.push(itemValue)
    //                 }
    //               }
    //             }
    //           } else if (!enumStr.includes(':')) {
    //             this.$message.error('枚举值请使用key:value格式')
    //             return
    //           }
    //         }
    //       }
    //       let params = Object.assign({}, topField, { dataExtInfoList: extFileds })
    //       if (this.action == 'edit') {
    //         params.appId = this.appId
    //         // console.log('修改参数',params)
    //       }
    //       this.handleSave({ params, type: this.action })
    //     }
    //   });
    // },
    //变更所属系统对象
    changeSelectObj(obj) {
      // console.log(obj)
      this.dto.appCode = obj.appCode;
      this.dto.appName = obj.appName;
      this.dto.appId = obj.id;
    },
    //修改时数据类型参数
    chooseEditParam() {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].appCode == this.dto.appCode) {
          this.appId = this.options[i].id;
        }
      }
    },

    //重新整理租户参数
    toEnd() {
      //重新整理 修改入参  10.18 this.$store.getters.tenementCode
      if (this.action == "add") {
        this.dto = Object.assign(
          {},
          this.dto,
          { tenementId: this.$store.state.app.tenementInfoObj.id },
          { tenementCode: this.$store.state.app.tenementInfoObj.tenementCode }
        );
      }
      return this.dto;
      //  return _.pick(this.dto, this.allFieldKeys)
    },

    handleClose() {
      this.updateVis(false);
      this.$refs["form"].resetFields();
      this.updateState("entity");
      //'typeName', 'typeCode', 'remark',
      // this.dto.typeName=''
      this.dto.typeName = undefined;
      this.dto.typeCode = undefined;
      this.dto.remark = undefined;
      this.dto.appCode = undefined;
      this.dto.appName = undefined;
      this.dto.dataExtInfoList.forEach((item, index) => {
        item.extNo = index + 1;
        item.extName = "";
        item.isEffective = 0;
        item.isShowName = 0;
        item.isUnique = 0;
        item.isRequired = 0;
        item.isEnum = 0;
        item.enumValue = "";
      });
    },
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        const extFileds = this.checkParams();
        if (extFileds) {
          let topField = this.toEnd();
          if (this.dto.appName) {
            topField = _.omit(topField, "appName");
          }
          let params = Object.assign({}, topField, { dataExtInfoList: extFileds });
          if (this.action == "edit") {
            params.appId = this.appId;
          }
          this.handleSave({ params, type: this.action });
        }
      });
    },
    checkParams() {
      const extFileds = _.cloneDeep(this.dto.dataExtInfoList);
      if (!extFileds.some((item) => item.isRequired === 1)) {
        this.$message.error(`${this.$t('language.5o6vkto5zyw0')}`);
        return;
      }
      for (let i = 0, len = extFileds.length; i < len; i++) {
        const row = extFileds[i];
        const nextRow = i !== len - 1 ? extFileds[i + 1] : {};
        if (row.isEffective === 0 && nextRow.isEffective === 1 && i !== len - 1) {
          this.$message.error(`${this.$t('language.5o6vkto600s0')}`);
          return;
        }
        // 將null&undefined轉為字符串
        row.enumValue = typeof row.enumValue === "string" ? row.enumValue.trim() : "";
        row.extName = typeof row.extName === "string" ? row.extName.trim() : row.extName;
        if (row.isEffective === 1 && _.isEmpty(row.extName)) {
          this.$message.error(`${this.$t('language.5o6vkto602w0')}`);
          return;
        }
        if (typeof row.extName === "string" && row.extName.length > 10) {
          this.$message.error(`${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqm44hb0')}`);
          return;
        }
        if (row.isEffective === 1 && !CNST.REG_EXP.ENGNUMLINEZH.test(row.extName)) {
          this.$message.error(
            `${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqm44hl0')}`
          );
          return;
        }
        if (typeof row.enumValue === "string" && row.enumValue.length > 500) {
          this.$message.error(`${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqm44hko')}`);
          return;
        }
        if (row.isEnum === 1 && _.isEmpty(row.enumValue.trim())) {
          this.$message.error(`${this.$t('language.5o6vkto604k0')}`);
          return;
        }
        // 不允许最后一个字符为逗号
        if (
          row.isEnum === 1 &&
          row.enumValue.length &&
          row.enumValue[row.enumValue.length - 1] === ","
        ) {
          this.$message.error(`${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uhqm44hk0')}`);
          return;
        }
        if (row.isEnum === 1 && !_.isEmpty(row.enumValue)) {
          const enumStr = row.enumValue;
          if (enumStr.includes(",")) {
            const keys = [];
            const values = [];
            const array = enumStr.split(",");
            for (let j = 0; j < array.length; j++) {
              if (!CNST.REG_EXP.ENUM_VALUE_STR.test(array[j])) {
                this.$message.error(
                  `${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqmi4hk0')}`
                );
                return;
              }
              const itemInfo = array[j].split(":");
              const itemKey = itemInfo[0].trim();
              const itemValue = itemInfo[1].trim();
              if (!itemKey || !itemValue) {
                this.$message.error(`${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uh9m44hk0')}`);
                return;
              }
              if (keys.includes(itemKey)) {
                this.$message.error(
                  `${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uhqm44hl0')}${itemKey}${this.$t('language.5o6uhqm4yhk0')}`
                );
                return;
              } else {
                keys.push(itemKey);
              }
              if (values.includes(itemValue)) {
                this.$message.error(
                  `${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uhqm4phl0')}${itemValue}${this.$t('language.5o6uhqm4yhk0')}`
                );
                return;
              } else {
                values.push(itemValue);
              }
            }
          } else if (!CNST.REG_EXP.ENUM_VALUE_STR.test(enumStr)) {
            this.$message.error(
              `${$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqmi4hk0')}`
            );
            return;
          }
        }
      }
      return extFileds;
    },
  },
  watch: {
    dto(newVal) {
      if (this.action != "add") {
        const dtoArrLength = this.dto.dataExtInfoList.length;
        for (let i = 0; i < 18 - dtoArrLength; i++) {
          this.dto.dataExtInfoList.push({
            extNo: dtoArrLength + i + 1,
            extName: "",
            isEffective: 0,
            isShowName: 0,
            isUnique: 0,
            typeId: "",
            isRequired: 0,
            isEnum: 0,
            enumValue: "",
          });
        }
      }
    },
    visible(newVal) {
      if (newVal) {
        if (this.action === "add" && this.appList.length) {
          this.dto.appCode = this.appList[0].appCode;
          this.dto.appName = this.appList[0].appName;
          this.dto.appId = this.appList[0].id;
        }
        // console.log(this.entity)
      }
    },
    action(newVal) {
      if (newVal == "add") {
        this.addOrEdit = this.buttonData("tjsjlx").name;
      } else if (newVal == "edit") {
        this.addOrEdit = this.buttonData("bjsjlx").name;
      } else {
        this.addOrEdit = this.buttonData("sjlxxq").name;
      }
    },
  },
};
</script>

<style lang="scss" scope>
.dataTypeDlg {
  .el-table .cell {
    text-align: center;
  }
}
</style>
